import React from 'react'
import Ubication from '../../../assets/svg/Ubication'
import './ActionDetailMapTitle.css'

function ActionDetailMapTitle({ title }) {
    return (
        <div className="container-map-title_container">
            <div className="planDetail-box_container-map_title">
                <p>
                    <Ubication className="UbicationIcon" />
                    {title}
                </p>
            </div>
        </div>
    )
}

export default ActionDetailMapTitle
